import React from 'react';
import { Button, Grid } from '@material-ui/core';
import evento from 'data/evento.json';
import { useDevice } from 'components/DeviceContext.js';

function CardInscricao() {
    const { isMobile, isLaptop } = useDevice();
    const hasEventoInfo = evento.title && evento.event && evento.date && evento.day && evento.time && evento.location && evento.programButton && evento.programButton.url && evento.programButton.text && evento.registerButton && evento.registerButton.url && evento.registerButton.text;

    const handleScrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };
    return (
        <>
            {hasEventoInfo && (
                <Grid style={{ border: '2px solid var(--branco)', color: 'var(--branco)', borderRadius: '1em', padding: '1em', maxWidth: isMobile ? '300px' : isLaptop ? '400px' : '500px', height: isMobile ? '300px' : isLaptop ? '400px' : '450px', backgroundColor: 'rgba(0, 0, 255, 0.2)', textAlign: 'center' }}>
                    <p style={{ color: 'var(--amarelo)', textTransform: 'uppercase', fontWeight: '700', fontSize: isMobile ? '14px' : isLaptop ? '16px' : '18px' }}>{evento.title}</p>
                    <span style={{ fontWeight: '800', fontSize: isMobile ? '22px' : isLaptop ? '31px' : '35px' }}>{evento.event}</span>
                    <Grid style={{ textAlign: 'center' }}>
                        <p style={{ fontWeight: '800', fontSize: isMobile ? '20px' : isLaptop ? '40px' : '60px' }}>
                            {evento.date.split('/')[0]}
                            <span style={{ color: 'var(--amarelo)' }}>/</span>
                            {evento.date.split('/')[1]}
                            <span style={{ color: 'var(--amarelo)' }}>/</span>
                            {evento.date.split('/')[2]}
                        </p>
                        <p style={{ color: 'var(--amarelo)', fontSize: isMobile ? '14px' : isLaptop ? '18px' : '24px' }}>{`${evento.day} - ${evento.time} - ${evento.location}`}</p>
                        <Grid style={{
                            display: 'flex',
                            justifyContent: 'space-around',
                        }}>
                            <Button variant="outlined" style={{
                                border: '5',
                                color: 'var(--branco)',
                                borderRadius: '1em'
                            }} onClick={() => handleScrollToSection('programacao')}>
                                {evento.programButton.text}
                            </Button>
                            <Button variant="outlined" style={{
                                backgroundColor: 'var(--amarelo)',
                                color: 'var(--azul)',
                                borderRadius: '1em'
                            }} href={evento.registerButton.url} target="_blank" rel="noopener noreferrer">
                                {evento.registerButton.text}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </>
    );
}

export default CardInscricao;
